<template>
  <div
    class="chats"
    :class="{'chats-right': isCurrentUser}"
  >
    <UserAvatar v-if="avatar" :user="message.user" chat online/>

    <div v-if="message.user.profile" class="chat-content">
      <div class="chat-profile-name">
        <h6>
          {{ message.user.profile.display_name }}
          <span>{{ timeFormat(message.timestamp) }}</span>
          <span v-if="message.starred" class="check-star">
            <i class="bx bxs-star"></i>
          </span>
        </h6>
      </div>

      <div
        :class="{'message-emoji': message.type === 'emoji'}"
        class="message-content award-link chat-award-link"
        v-html="message.content"
      />
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {timeFormat} from '@/util';
import UserAvatar from "@/components/frontend/UserAvatar";

export default {
  components: {UserAvatar},
  props: {
    message: {
      type: Object,
      required: true
    },

    avatar: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      currentChatUser: 'chat/currentChatUser',
      activeUsers: 'chat/activeUsers',
    }),

    isCurrentUser() {
      return this.message.user_id === this.currentChatUser.id;
    },
  },

  data() {
    return {
      //
    }
  },

  methods: {
    timeFormat,
    toggleSidebarThree() {
      this.$eventHub.$emit('toggleThirdSidebar')
    }
  }
}
</script>
